import {create} from "zustand";
import { GetOrderApartmentsLookupListItem, GetOrderAuthorsLookupListItem, GetOrderServicesLookupListItem, OrderListItemResponseDto, OrderStatus } from '@/features/orders/types/orders-dto';

const DEFAULT_PAGE_SIZE = 10;

type OrdersFilterType = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        take: number;
        skip?: number;
        authorId?: GetOrderAuthorsLookupListItem[];
        apartmentId?: GetOrderApartmentsLookupListItem[];
        serviceId?: GetOrderServicesLookupListItem[];
        orderStatus?: OrderStatus | null;
        amountRange?: string | null;
        orderBy?: Capitalize<keyof OrderListItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
    },
    setFilter: ( filter: Partial<OrdersFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: OrdersFilterType['filter'] = {
    startDate: null,
    endDate: null,
    take: DEFAULT_PAGE_SIZE,
    skip: 0, 
    authorId: [],
    apartmentId: [], 
    serviceId: [], 
    orderStatus: null, 
    amountRange: null, 
    orderBy: null, 
    orderDirection: 'asc', 
};

export const useOrdersFilter = create<OrdersFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));